import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

let request = null;
// Public shop facts (shipping, free-shipping threshold); fetched once per page load.
export const useShopInfo = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => { request ||= studioApi('/checkout-settings').catch(() => { request = null; return null; }); request.then(setInfo); }, []);
  return info;
};
